import { postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";

const circularity = apiUrl + "/circularity";
const routes = {
  label: "Circularity",
  root: circularity,
  get_by_env_factor_ids: circularity + "/get_by_env_factor_ids",
  ai_suggest: circularity + "/ai_suggest",
  update_cost_per_unit: circularity + "/update_cost_per_unit",
  update_end_of_lifes_materials: circularity + "/update_end_of_lifes_materials",
  update_input_materials: circularity + "/update_input_materials",
  update_output_materials: circularity + "/update_output_materials",
  update_utilities: circularity + "/update_utilities",
};

export const Circularity = {
  label: routes.label,
  update_cost_per_unit: (list) => postWithToken(routes.update_cost_per_unit, list),
  get_by_env_factor_ids: (ids) => postWithToken(routes.get_by_env_factor_ids, { ids }),
  ai_suggest: (payload) => postWithToken(routes.ai_suggest, payload),

  update_input_materials: (im) => postWithToken(routes.update_input_materials, im),
  update_output_materials: (om) => postWithToken(routes.update_output_materials, om),
  update_utilities: (ut) => postWithToken(routes.update_utilities, ut),
  update_end_of_lifes_materials: (eol) => postWithToken(routes.update_end_of_lifes_materials, eol),
};
